import { Badge } from "../components/ui/badge";

const SLA_CONFIG = {
  on_track: { label: "On Track", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  warning: { label: "At Risk", className: "bg-amber-50 text-amber-700 border-amber-200 sla-pulse" },
  late: { label: "Late", className: "bg-red-50 text-red-700 border-red-200 sla-pulse" },
  completed: { label: "Done", className: "bg-slate-50 text-slate-500 border-slate-200" },
};

export default function SLABadge({ sla, showDays = true }) {
  if (!sla) return null;
  const config = SLA_CONFIG[sla.status] || SLA_CONFIG.on_track;
  return (
    <Badge
      data-testid="sla-badge"
      variant="outline"
      className={`${config.className} text-[10px] uppercase tracking-wider font-semibold border`}
    >
      {config.label}
      {showDays && sla.status !== "completed" && (
        <span className="ml-1 opacity-75">{sla.days_remaining}d left</span>
      )}
    </Badge>
  );
}
